const initialState = {
  schForm: {
    storeCode: "",
  },
  membershipList: "",
  mForm: "",
  membership: "",
  membershipImg: "",
  initState: false,
  loading: true,
};

export const INIT_MEMBERSHIP = "INIT_MEMBERSHIP";
export const init = (data) => ({
  type: INIT_MEMBERSHIP,
  payload: data,
});

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const SET_FORM = "SET_FORM";
export const schFormAction = (data) => ({
  type: SET_FORM,
  payload: data,
});

export const LOAD_MEMBERSHIP_LIST = "LOAD_MEMBERSHIP_LIST";
export const loadMembershipListAction = (data) => ({
  type: LOAD_MEMBERSHIP_LIST,
  payload: data,
});

export const LOAD_MEMBERSHIP_LIST_SUCCESS = "LOAD_MEMBERSHIP_LIST_SUCCESS";
export const loadMembershipListSuccessAction = (list) => ({
  type: LOAD_MEMBERSHIP_LIST_SUCCESS,
  payload: list,
});

export const LOAD_MEMBERSHIP = "LOAD_MEMBERSHIP";
export const loadMembershipAction = (data) => ({
  type: LOAD_MEMBERSHIP,
  payload: data,
});

export const LOAD_MEMBERSHIP_SUCCESS = "LOAD_MEMBERSHIP_SUCCESS";
export const loadMembershipSuccessAction = (data) => ({
  type: LOAD_MEMBERSHIP_SUCCESS,
  payload: data,
});

export const LOAD_MEMBERSHIP_IMG = "LOAD_MEMBERSHIP_IMG";
export const loadMembershipImgAction = (data) => ({
  type: LOAD_MEMBERSHIP_IMG,
  payload: data,
});

export const LOAD_MEMBERSHIP_IMG_SUCCESS = "LOAD_MEMBERSHIP_IMG_SUCCESS";
export const loadMembershipImgSuccessAction = (data) => ({
  type: LOAD_MEMBERSHIP_IMG_SUCCESS,
  payload: data,
});

export default function MembershipReducer(state = initialState, action) {
  const { type, payload, error } = action;

  console.log("MembershipReducer = type", type, "payload", payload);

  switch (type) {
    case INIT_MEMBERSHIP:
      return {
        ...initialState,
      };
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case SET_FORM:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_MEMBERSHIP_LIST:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_MEMBERSHIP_LIST_SUCCESS:
      return {
        ...state,
        membershipList: payload,
        loading: false,
      };
    case LOAD_MEMBERSHIP:
      return {
        ...state,
        mForm: payload,
      };
    case LOAD_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        membership: payload,
        loading: false,
      };
    case LOAD_MEMBERSHIP_IMG:
      return {
        ...state,
      };
    case LOAD_MEMBERSHIP_IMG_SUCCESS:
      return {
        ...state,
        membershipImg: payload,
        loading: false,
      };
    default:
      return state;
  }
}
